export const css = {
	root: '_1pjZBxob',
	' _key': 'apic-theme/apic/landing-page/general'
};

export default css;
